// src/Leaderboard.js
import React, { useState, useEffect } from 'react';

function Leaderboard() {
  const [creditsLeaderboard, setCreditsLeaderboard] = useState([]);
  const [challengesLeaderboard, setChallengesLeaderboard] = useState([]);
  const [error, setError] = useState(null);

  // Fetch leaderboard by credits
  useEffect(() => {
    fetch("https://auth.fnrewards.com/api/leaderboard/credits", {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => setCreditsLeaderboard(data.leaderboard))
      .catch(err => setError(err.message));
  }, []);

  // Fetch leaderboard by challenges completed
  useEffect(() => {
    fetch("https://auth.fnrewards.com/api/leaderboard/challenges", {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => setChallengesLeaderboard(data.leaderboard))
      .catch(err => console.error(err));
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h1>Leaderboards</h1>
      {error && <p style={{ color: "red" }}>Error: {error}</p>}
      
      <h2>Most Credits Earned</h2>
      <ol>
        {creditsLeaderboard.map((user, index) => (
          <li key={index}>
            {user.first_name} {user.last_name} ({user.email}) – {user.credits} credits
          </li>
        ))}
      </ol>

      <h2>Most Challenges Completed</h2>
      <ol>
        {challengesLeaderboard.map((user, index) => (
          <li key={index}>
            {user.first_name} {user.last_name} ({user.email}) – {user.challenges_completed} challenges
          </li>
        ))}
      </ol>
    </div>
  );
}

export default Leaderboard;